import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./FeedDetailPage.module.css";

// 샘플 데이터 - 실제로는 API에서 가져오거나 상태 관리 라이브러리를 사용하세요
const sampleFeeds = [
  {
    id: "1",
    profileImage: `${process.env.PUBLIC_URL}/images/sample/profile1.svg`,
    nickname: "봄이 집사",
    userType: "대표",
    petInfo: "코리아 쇼트헤어 • 4살 • 6kg",
    content:
      "오늘도 봄이 낮깨서는 산책 중 ^^ 산책하는 고양이 보셨나요 다들~? 귀여운 우리봄이 언니가 너무너무 사랑해 누가 뭐래도 우리 봄이가 제일 예뻐",
    images: [`${process.env.PUBLIC_URL}/images/sample/cat1.png`],
    tags: ["고양이", "산책냥이"],
    postedAt: "2일 전",
    likes: 120,
    comments: 45,
  },
  {
    id: "2",
    profileImage: `${process.env.PUBLIC_URL}/images/sample/profile1.svg`,
    nickname: "봄이 집사",
    userType: "대표",
    petInfo: "코리아 쇼트헤어 • 4살 • 6kg",
    content:
      "오늘도 봄이 낮깨서는 산책 중 ^^ 산책하는 고양이 보셨나요 다들~? 귀여운 우리봄이 언니가 너무너무 사랑해 누가 뭐래도 우리 봄이가 제일 예뻐",
    images: [
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
    ],
    tags: ["고양이", "산책냥이"],
    postedAt: "2일 전",
    likes: 85,
    comments: 32,
  },
  {
    id: "3",
    profileImage: `${process.env.PUBLIC_URL}/images/sample/profile1.svg`,
    nickname: "봄이 집사",
    userType: "대표",
    petInfo: "코리아 쇼트헤어 • 4살 • 6kg",
    content:
      "오늘도 봄이 낮깨서는 산책 중 ^^ 산책하는 고양이 보셨나요 다들~? 귀여운 우리봄이 언니가 너무너무 사랑해 누가 뭐래도 우리 봄이가 제일 예뻐",
    images: [
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
    ],
    tags: ["고양이", "산책냥이"],
    postedAt: "2일 전",
    likes: 92,
    comments: 28,
  },
  {
    id: "4",
    profileImage: `${process.env.PUBLIC_URL}/images/sample/profile1.svg`,
    nickname: "봄이 집사",
    userType: "대표",
    petInfo: "코리아 쇼트헤어 • 4살 • 6kg",
    content:
      "오늘도 봄이 낮깨서는 산책 중 ^^ 산책하는 고양이 보셨나요 다들~? 귀여운 우리봄이 언니가 너무너무 사랑해 누가 뭐래도 우리 봄이가 제일 예뻐",
    images: [
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
    ],
    tags: ["고양이", "산책냥이"],
    postedAt: "2일 전",
    likes: 110,
    comments: 38,
  },
  {
    id: "5",
    profileImage: `${process.env.PUBLIC_URL}/images/sample/profile1.svg`,
    nickname: "봄이 집사",
    userType: "대표",
    petInfo: "코리아 쇼트헤어 • 4살 • 6kg",
    content:
      "오늘도 봄이 낮깨서는 산책 중 ^^ 산책하는 고양이 보셨나요 다들~? 귀여운 우리봄이 언니가 너무너무 사랑해 누가 뭐래도 우리 봄이가 제일 예뻐",
    images: [
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
      `${process.env.PUBLIC_URL}/images/sample/cat1.png`,
    ],
    tags: ["고양이", "산책냥이"],
    postedAt: "2일 전",
    likes: 75,
    comments: 20,
  },
];

const FeedDetailPage: React.FC = () => {
  const { feedId } = useParams<{ feedId: string }>();
  const navigate = useNavigate();

  // 실제로는 API에서 데이터를 가져옵니다
  const feed = sampleFeeds.find((feed) => feed.id === feedId);

  if (!feed) {
    return <div className={styles.notFound}>피드를 찾을 수 없습니다.</div>;
  }

  // 이미지 개수에 따른 클래스명을 반환하는 함수
  const getImageGalleryClass = () => {
    if (!feed.images || feed.images.length === 0) return "";
    if (feed.images.length === 1) return styles.count1;
    if (feed.images.length === 2) return styles.count2;
    if (feed.images.length === 3) return styles.count3;
    return styles.countMany;
  };

  // 피드 공유 함수
  const handleShareFeed = async () => {
    if (!feed) return;

    try {
      if (navigator.share) {
        await navigator.share({
          title: `${feed.nickname}의 게시물`,
          text: feed.content,
          url: window.location.href,
        });
      } else {
        // Web Share API를 지원하지 않는 브라우저를 위한 대체 방법
        alert("공유 기능을 지원하지 않는 브라우저입니다. URL을 복사해주세요.");
        // URL을 클립보드에 복사
        await navigator.clipboard.writeText(window.location.href);
        alert("URL이 클립보드에 복사되었습니다.");
      }
    } catch (error) {
      console.error("공유 중 오류 발생:", error);
    }
  };

  return (
    <div className={styles.detailPage}>
      <header className={styles.detailHeader}>
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/back-arrow.svg`}
            alt="뒤로 가기"
            onError={(e) => {
              e.currentTarget.src = `${process.env.PUBLIC_URL}/images/icons/back.png`;
            }}
          />
        </button>
        <h1 className={styles.detailTitle}>게시글</h1>
      </header>

      <div className={styles.feedDetail}>
        <div className={styles.userHeader}>
          <img
            src={feed.profileImage}
            alt={feed.nickname}
            className={styles.profileImage}
          />
          <div className={styles.userDetails}>
            <div className={styles.nameRow}>
              <h3 className={styles.userName}>{feed.nickname}</h3>
              <span className={styles.userType}>{feed.userType}</span>
            </div>
            <p className={styles.petInfo}>{feed.petInfo}</p>
          </div>
          <span className={styles.postedTime}>{feed.postedAt}</span>
        </div>

        <p className={styles.contentText}>{feed.content}</p>

        <div className={`${styles.imageGallery} ${getImageGalleryClass()}`}>
          {feed.images.map((image, index) => (
            <div key={index} className={styles.galleryImage}>
              <img src={image} alt={`게시물 이미지 ${index + 1}`} />
            </div>
          ))}
        </div>

        <div className={styles.tags}>
          {feed.tags.map((tag, index) => (
            <span key={index} className={styles.tag}>
              #{tag}
            </span>
          ))}
        </div>

        <div className={styles.stats}>
          <div className={styles.stat}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/feed-like.png`}
              alt="좋아요"
              onError={(e) => {
                e.currentTarget.src = `${process.env.PUBLIC_URL}/images/icons/like.png`;
              }}
            />
            <span>{feed.likes}</span>
          </div>
          <div className={styles.stat}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/feed-reply.svg`}
              alt="댓글"
              onError={(e) => {
                e.currentTarget.src = `${process.env.PUBLIC_URL}/images/icons/comment.png`;
              }}
            />
            <span>{feed.comments}</span>
          </div>
        </div>

        <div className={styles.actions}>
          <button className={styles.actionButton}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/feed-like.png`}
              alt="좋아요"
              onError={(e) => {
                e.currentTarget.src = `${process.env.PUBLIC_URL}/images/icons/like.png`;
              }}
            />
            좋아요
          </button>
          <button className={styles.actionButton}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/feed-reply.svg`}
              alt="댓글"
              onError={(e) => {
                e.currentTarget.src = `${process.env.PUBLIC_URL}/images/icons/comment.png`;
              }}
            />
            댓글
          </button>
          <button className={styles.actionButton} onClick={handleShareFeed}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/feed-share.svg`}
              alt="공유"
              onError={(e) => {
                e.currentTarget.src = `${process.env.PUBLIC_URL}/images/icons/share.png`;
              }}
            />
            공유
          </button>
        </div>

        <div className={styles.commentsSection}>
          <h4 className={styles.commentsTitle}>댓글 {feed.comments}개</h4>
          <div className={styles.noComments}>첫 댓글을 남겨보세요!</div>
        </div>
      </div>
    </div>
  );
};

export default FeedDetailPage;
